import { Component, type ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { CookieService } from 'ngx-cookie-service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { FullLoaderService } from 'src/app/shared/services/full-loader.service';
import { ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { SettingsService } from '../../settings/settings.service';

@Component({
  selector: 'app-service-supplier-quote-list',
  templateUrl: './service-supplier-quote-list.component.html',
  styleUrls: ['./service-supplier-quote-list.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceSupplierQuoteListComponent {
  @ViewChild('archivedSection', { static: false })
  archivedSection!: ElementRef;
  @ViewChild('heading', { static: false })
  heading!: ElementRef;
  menuTrigger: MatMenuTrigger | null = null;

  showLoader: boolean = false;
  searchKeyword: string = '';
  userRole!: string;
  issupplier: boolean | undefined;
  limit: number = 10;
  offset: number = 0;
  archivedLimit: number = 10;
  archivedOffset: number = 0;
  totalRecords: number = 0;
  archivedTotalRecords: number = 0;
  sortField: string = 'quotationSubmissionDate';
  sortDirection: string = 'DESC';
  docStatus: any;
  fromDate: any;
  toDate: any;
  operationType: string = 'supplierServiceQuote';

  documentData: any[] = [];
  AllQuotes: any;
  archivedDocumentData: any[] = [];
  isFilterExpand: boolean = false;
  isArchivedExpand: boolean = false;
  archivedLoaded: boolean = false;
  searchParam: string = '';
  selectedRfq: number[] = [];
  selectedQuote: number[] = [];
  selectedArchivedRfq: number[] = [];
  selectedArchivedQuotes: number[] = [];
  selectedStatus: string = 'ALL';

  rfqStagesList = [
    { name: 'Unactioned', heading: 'RFQ Recieved:' },
    { name: 'Acknowledged', heading: 'RFQ Acknowledged:' },
    { name: 'Declined', heading: 'RFQ Declined:' },
    { name: 'Lost', heading: 'RFQ Lost:' },
    { name: 'Lapsed', heading: 'RFQ Lapsed:' },
  ];

  quoteStagesList = [
    { name: 'Accepted', heading: 'Quotation Recieved' },
    { name: 'Declined', heading: 'Quotation Declined:' },
    { name: 'Draft', heading: 'Quotation Drafted:' },
    { name: 'Withdrawn', heading: 'Quote Withdrawn:' },
    { name: 'Approved', heading: 'Quotation Approved:' },
    { name: 'Rejected', heading: 'Quotation Rejected:' },
    { name: 'Submitted', heading: 'Quotation Submitted:' },
  ];

  filterStatuses = [
    { name: 'Accepted', label: 'Quote' },
    { name: 'Declined', label: 'Quote' },
    { name: 'Draft', label: 'Quote' },
    { name: 'Quoted', label: 'Quote' },
    { name: 'Withdrawn', label: 'Quote' },
    { name: 'ALL', label: 'Quote' },
  ];

  statusColors: { [key: string]: string } = {
    Accepted: '#00B3B3',
    Quoted: '#1ebd60',
    Declined: '#FF0000',
    Withdrawn: '#fa5858',
    Draft: '#000000',
    Lost: '#FF0000',
    Lapsed: '#FF8A00',
    Unactioned: '#727272',
  };

  activeIndex: number = this.filterStatuses.length - 1;

  quoteStatuses: any[] = [
    'Unactioned', 'Accepted', 'Quoted', 'Under Review',
    'Clarification Requested', 'Approved', 'Declined', 'Awarded',
    'Closed', 'Open', 'In Review', 'Awaiting Supplier Response',
    'Canceled', 'Draft', 'Withdrawn', 'Lost',
  ];

  supplierUsersList: any[] = [];
  selectedUsers: any[] = [];
  useroffset: number = 0;
  userlimit: number = 10;
  isLoading: boolean = false;

  columns = [
    { name: 'Buyer', prop: 'companyName', visible: true },
    { name: 'Document Type', prop: 'docType', visible: true },
    { name: 'Quote Reference', prop: 'quoteRefNumber', visible: true },
    { name: 'Reference', prop: 'rfqRefNumber', visible: true },
    { name: 'Approved By', prop: 'approvedBy', visible: true },
    { name: 'Status', prop: 'docStatus', visible: true },
    { name: 'Quotation Date', prop: 'quotationDate', visible: true },
    { name: 'Date', prop: 'rfqDate', visible: true },
    { name: 'Quote before date', prop: 'quotedByDate', visible: false },
    { name: 'Vessel', prop: 'vesselName', visible: false },
    { name: 'Port Country', prop: 'portCountry', visible: false },
    { name: 'Port Name', prop: 'portName', visible: false },
    { name: 'Buyer Contact Name', prop: 'contact', visible: false },
    { name: 'Delivery date', prop: 'requestDeliveryDate', visible: false },
  ];

  items = [
    { label: 'Request Delivery Date', prop: 'requestDeliveryDate', selected: false },
    { label: 'Vessel ETA', prop: 'vesselEta', selected: false },
    { label: 'Vessel ETD', prop: 'vesselEtd', selected: false },
    { label: 'Quote before date', prop: 'quotedByDate', selected: false },
    { label: 'Price Good Until', prop: 'pricesGoodUntil', selected: false },
    { label: 'Payment Terms', prop: 'paymentTermsAndConditions', selected: false },
    { label: 'Total Price', prop: 'totalPrice', selected: false },
    { label: 'Vessel Name', prop: 'vesselName', selected: false },
  ];

  archivedItems = [
    { label: 'Request Delivery Date', prop: 'requestDeliveryDate', selected: false },
    { label: 'Vessel ETA', prop: 'vesselEta', selected: false },
    { label: 'Vessel ETD', prop: 'vesselEtd', selected: false },
    { label: 'Quote before date', prop: 'quotedByDate', selected: false },
    { label: 'Price Good Until', prop: 'pricesGoodUntil', selected: false },
    { label: 'Payment Terms', prop: 'paymentTermsAndConditions', selected: false },
    { label: 'Total Price', prop: 'totalPrice', selected: false },
    { label: 'Vessel Name', prop: 'vesselName', selected: false },
  ];

  selectedColumns: { label: string; prop: string }[] = [];
  archivedSelectedColumns: { label: string; prop: string }[] = [];

  labelFromRFQ: string = '';

  otherStatus = [
    { name: 'Acknowledged', label: 'RFQ' },
    { name: 'Declined', label: 'RFQ' },
    { name: 'Lost', label: 'RFQ' },
    { name: 'Lapsed', label: 'RFQ' },
    { name: 'Unactioned', label: 'RFQ' },
  ];

  dropdownOpen: boolean = false;
  quoteTypeDropdownOpen: boolean = false;
  previewSection = false;
  previewDocs: string[] = [];
  showContactPopup: boolean = false;
  selectedBuyer: any = {
    companyName: 'N/A', contactPerson: 'N/A', email: 'N/A',
    phone: 'N/A', address: 'N/A', fax: 'N/A',
  };

  expandedQuoteId: number | null = null;
  private shouldAutoExpandFirst: boolean = true;
  private hasAutoExpandedAllOnce: boolean = false;

  constructor(
    private SettingsService: SettingsService,
    private router: Router,
    private cookieService: CookieService,
    private snack: MatSnackBar,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private fullLoaderService: FullLoaderService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
  ) {
    iconRegistry.addSvgIcon(
      'downloadExcel',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        `${environment.assetsLink}images/excel.svg`
      )
    );
  }

  async ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      const statusParam = params['selectedStatus'];
      const labelParam = params['label'];
      if (statusParam && labelParam) {
        this.selectedStatus = statusParam;
        this.labelFromRFQ = labelParam;
        this.docStatus = statusParam;
        this.setActiveStatus(statusParam, labelParam);
      } else {
        this.docStatus = 'ALL';
        this.selectedStatus = 'ALL';
      }
    });

    this.userRole = this.cookieService.get('userRole');
    if (this.userRole == 'Suppliers') {
      this.issupplier = true;
    }

    await this.fetchAllDocuments();
  }

  // ── Data fetching (real API via SettingsService) ──

  async fetchAllDocuments() {
    const fromDate = this.fromDate
      ? moment(this.fromDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;
    const toDate = this.toDate
      ? moment(this.toDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;

    this.operationType = 'supplierServiceQuote';
    try {
      this.showLoader = true;
      this.cdr.markForCheck();

      const response = await this.SettingsService.fetchServiceQuoteDetailsBySupplierId(
        this.searchParam,
        Number(this.cookieService.get('userId')),
        this.docStatus,
        fromDate,
        toDate,
        this.sortField,
        this.sortDirection,
        this.limit,
        this.offset,
        1,
        this.operationType
      );

      if (response && Array.isArray(response.rows)) {
        this.documentData = response.rows.map((row: any) => {
          const r = { ...row };
          const currentDate = new Date();
          const quotedByDate = new Date(r.quotedByDate);
          if (r.docStatus === 'Unactioned' && quotedByDate < currentDate) {
            r.docStatus = 'Lapsed';
          }
          r.id = r.id ?? r.quoteId;
          r.statusColor = this.statusColors?.[r.docStatus] || '#727272';
          r.remaining = this.getRemainingTime(r);
          return r;
        });
        this.totalRecords = response.totalElements ?? 0;

        // Auto-expand first row
        if (this.expandedQuoteId == null && this.documentData.length > 0 && this.shouldAutoExpandFirst) {
          const first = this.documentData[0];
          this.expandedQuoteId = first.quoteId;
          if (!first.statusesStages) {
            first.statusesStages = this.buildRfqStages(first);
            first.statusesStages = this.buildQuoteStages(first);
            first.statusesStages = this.buildOtherStages(first);
          }
          this.hasAutoExpandedAllOnce = true;
          this.shouldAutoExpandFirst = false;
        }

        // If a row is already expanded, ensure it has stages
        if (this.expandedQuoteId != null) {
          const match = this.documentData.find((r: any) => r.quoteId === this.expandedQuoteId);
          if (match && !match.statusesStages) {
            match.statusesStages = this.buildRfqStages(match);
            match.statusesStages = this.buildQuoteStages(match);
            match.statusesStages = this.buildOtherStages(match);
          }
        }
      }
    } catch (error) {
      console.error('Error fetching service quote documents:', error);
    } finally {
      this.showLoader = false;
      this.cdr.markForCheck();
    }
  }

  async fetchArchivedAllDocuments() {
    const fromDate = this.fromDate
      ? moment(this.fromDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;
    const toDate = this.toDate
      ? moment(this.toDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;

    this.operationType = 'supplierServiceQuote';
    try {
      this.showLoader = true;
      this.cdr.markForCheck();

      const response = await this.SettingsService.fetchServiceQuoteDetailsBySupplierId(
        this.searchParam,
        Number(this.cookieService.get('userId')),
        this.docStatus,
        fromDate,
        toDate,
        this.sortField,
        this.sortDirection,
        this.archivedLimit,
        this.archivedOffset,
        0, // isActive = 0 for archived
        this.operationType
      );

      if (response && Array.isArray(response.rows)) {
        this.archivedDocumentData = response.rows.map((row: any) => {
          const r = { ...row };
          const currentDate = new Date();
          const quotedByDate = new Date(r.quotedByDate);
          if (r.docStatus === 'Unactioned' && quotedByDate < currentDate) {
            r.docStatus = 'Lapsed';
          }
          r.id = r.id ?? r.quoteId;
          r.statusColor = this.statusColors?.[r.docStatus] || '#727272';
          return r;
        });
        this.archivedTotalRecords = response.totalElements ?? 0;
      }
    } catch (error) {
      console.error('Error fetching archived service quote documents:', error);
    } finally {
      this.showLoader = false;
      this.cdr.markForCheck();
    }
  }

  // ── UI Helpers (same as product) ──

  getHeadingFromLabel(label: string, entityType: 'RFQ' | 'Quote'): string {
    const list = entityType === 'RFQ' ? this.rfqStagesList : this.quoteStagesList;
    const match = list.find(stage => stage.name.toLowerCase() === label.toLowerCase());
    return match ? match.heading : label;
  }

  isRfqLapsed(quotedByDate: string | Date): boolean {
    return new Date() > new Date(quotedByDate);
  }

  formatDate(date: string | Date): string {
    return new Date(date).toLocaleDateString('en-GB');
  }

  setActiveStatus(status: string, label: string) {
    const index = this.filterStatuses.findIndex(s => s.name === status && s.label === label);
    if (index !== -1) {
      this.activeIndex = index;
      this.selectedStatus = status;
      this.docStatus = status;
    } else {
      this.docStatus = 'ALL';
      this.selectedStatus = 'ALL';
    }
  }

  async toggleUserSelection(item: any) {
    if (this.selectedRfq.length === 0) {
      this.snack.open('Please select at least one Quote before selecting a user.', 'OK', { duration: 3000 });
      return;
    }
    item.selected = !item.selected;
    if (item.selected) {
      try {
        this.fullLoaderService.showLoader('Assigning user...');
        await this.SettingsService.assignUserToServiceQuotes(
          this.selectedRfq,
          Number(this.cookieService.get('userId')),
          item.id
        );
        await this.fetchAllDocuments();
        this.selectedRfq = [];
        item.selected = false;
        this.snack.open('User assigned to Quote successfully.', 'OK', { duration: 3000 });
        this.fullLoaderService.hideLoader();
      } catch (error) {
        this.snack.open('Failed to assign user to Quote.', 'OK', { duration: 3000 });
        this.fullLoaderService.hideLoader();
      }
    }
  }

  getStatusColor(status: string): string {
    return this.statusColors[status] || '#000000';
  }

  formatRfqDate(rfqDate: any): string {
    const now = moment();
    const diffInSeconds = now.diff(moment(rfqDate), 'seconds');
    const diffInMinutes = now.diff(moment(rfqDate), 'minutes');
    const diffInHours = now.diff(moment(rfqDate), 'hours');
    const diffInDays = now.diff(moment(rfqDate), 'days');

    if (diffInSeconds < 60) return `${diffInSeconds} seconds ago`;
    else if (diffInMinutes < 60) return `${diffInMinutes} minutes ago`;
    else if (diffInHours < 24) return `${diffInHours} hours ago`;
    else if (diffInDays === 1) return 'Yesterday';
    else return moment(rfqDate).format('DD MMM YYYY');
  }

  getRemainingTime(row: any): { label: string; color: string; tooltip: string } {
    if (!row.quotedByDate || ['Lost', 'Declined'].includes(row.docStatus)) {
      if (row.docStatus == 'Declined') return { label: '-', color: 'black', tooltip: 'You have declined this RFQ' };
      else if (row.docStatus == 'Lost') return { label: '-', color: 'black', tooltip: 'RFQ awarded to another Supplier' };
      return { label: '-', color: 'black', tooltip: 'Quotation date Deadline not mentioned' };
    }
    const now = moment();
    const quoteDate = moment(row.quotedByDate);
    const diffInDays = quoteDate.diff(now, 'days');
    if (diffInDays > 7) return { label: 'New', color: '#0BA716', tooltip: `RFQ due in ${diffInDays} days` };
    else if (diffInDays >= 4) return { label: 'Standard', color: '#FD8900', tooltip: `RFQ due in ${diffInDays} days` };
    else if (diffInDays >= 1) return { label: 'Urgent', color: '#F60303', tooltip: `RFQ due in ${diffInDays} days` };
    else if (diffInDays < 0) return { label: '-', color: '#000000', tooltip: 'Quote window closed' };
    else return { label: 'Urgent', color: '#F60303', tooltip: 'RFQ due today' };
  }

  async onUserMenuOpened() {
    if (!this.supplierUsersList.length && !this.isLoading) {
      await this.fetchUsers();
    }
  }

  onScroll(): void {
    const menuContent = document.querySelector('.menu-content') as HTMLElement;
    if (
      menuContent.scrollTop + menuContent.clientHeight >=
        menuContent.scrollHeight &&
      !this.isLoading
    ) {
      if (this.supplierUsersList.length == this.userlimit * this.useroffset) {
        this.fetchUsers();
      } else {
        this.isLoading = false;
      }
    }
  }

  async fetchUsers(): Promise<void> {
    this.isLoading = true;
    try {
      const response = await this.SettingsService.fetchUserBySupplierId(
        Number(this.cookieService.get('userId')),
        this.userlimit,
        this.useroffset
      ).toPromise();
      if (response && Array.isArray(response.rows)) {
        this.supplierUsersList = [...this.supplierUsersList, ...response.rows];
        this.useroffset++;
      }
    } catch (error) {
      console.error('Error fetching supplier users:', error);
    } finally {
      this.isLoading = false;
      this.cdr.markForCheck();
    }
  }

  // ── Table interactions ──

  setRowClass = (row: any) => 'green-row-background';
  rowIdentity = (row: any) => row.quoteId;

  toggleSelection(item: any) {
    item.selected = !item.selected;
    this.updateSelectedColumns();
  }

  archivedToggleSelection(item: any) {
    item.selected = !item.selected;
    this.updateArchivedSelectedColumns();
  }

  updateSelectedColumns() {
    this.selectedColumns = this.items.filter(item => item.selected).map(item => ({ label: item.label, prop: item.prop }));
  }

  updateArchivedSelectedColumns() {
    this.archivedSelectedColumns = this.archivedItems.filter(item => item.selected).map(item => ({ label: item.label, prop: item.prop }));
  }

  isDate(value: any): boolean {
    return value instanceof Date || !isNaN(Date.parse(value));
  }

  onPageChange(event: any) {
    this.offset = event.offset;
    this.selectedRfq = [];
    this.fetchAllDocuments();
  }

  onSearch() {
    setTimeout(() => {
      this.offset = 0;
      this.fetchAllDocuments();
    }, 0);
  }

  onSort(event: any) {
    const sort = event.sorts[0];
    this.sortField = sort.prop;
    this.sortDirection = sort.dir;
    this.fetchAllDocuments();
  }

  onArchivedPageChange(event: any) {
    this.archivedOffset = event.offset;
    this.fetchArchivedAllDocuments();
  }

  onStatusSelect(status: string, index: number, label: string) {
    if (this.selectedStatus === status) return;
    if (label === 'Quote') {
      this.activeIndex = index;
      this.selectedStatus = status;
      this.offset = 0;
      this.docStatus = status;
      this.expandedQuoteId = null;
      this.shouldAutoExpandFirst = status === 'ALL' && !this.hasAutoExpandedAllOnce;
      this.fetchAllDocuments();
    } else if (label === 'RFQ') {
      this.router.navigate(['/operations/supplier-service-rfq-list'], {
        queryParams: { selectedStatus: status, label: label },
      });
    }
  }

  cancelFilter() {
    this.fromDate = null;
    this.toDate = null;
    this.offset = 0;
    this.archivedOffset = 0;
    this.selectedStatus = 'ALL';
    this.docStatus = 'ALL';
    this.searchParam = '';
    this.fetchAllDocuments();
    if (this.archivedLoaded) this.fetchArchivedAllDocuments();
  }

  toggleVisibility() {
    this.isFilterExpand = !this.isFilterExpand;
  }

  toggleArchived() {
    this.isArchivedExpand = !this.isArchivedExpand;
    if (this.isArchivedExpand && !this.archivedLoaded) {
      this.fetchArchivedAllDocuments();
      this.archivedLoaded = true;
    }
    if (this.isArchivedExpand && this.heading) {
      this.heading.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  toggleQuoteTypeDropdown() {
    this.quoteTypeDropdownOpen = !this.quoteTypeDropdownOpen;
  }

  navigateToQuoteType(type: string) {
    if (type === 'product') {
      this.router.navigate(['/operations/supplier-quote-list']);
    } else if (type === 'service') {
      this.router.navigate(['/operations/service-supplier-quote-list']);
    }
  }

  // ── Checkbox selection ──

  toggleSelectAll(event: any, section: string) {
    const checked = event.target.checked;
    if (section == 'active') {
      this.selectedRfq = checked ? this.documentData.map(item => item.quoteId) : [];
    } else {
      this.selectedArchivedRfq = checked ? this.archivedDocumentData.map(item => item.quoteId) : [];
    }
  }

  selectDeselectRfq(event: any, supplierRfqDetailsId: any, quoteId: any, section: string, owner: any) {
    const checked = event.target.checked;
    if (section == 'active') {
      if (checked) {
        this.selectedRfq.push(quoteId);
        if (owner !== null) {
          this.snack.open(`User is already assigned to Quote ID ${quoteId}`, 'OK', { duration: 5000 });
        }
      } else {
        this.selectedRfq = this.selectedRfq.filter(id => id !== quoteId);
      }
    } else {
      if (checked) this.selectedArchivedRfq.push(quoteId);
      else this.selectedArchivedRfq = this.selectedArchivedRfq.filter(id => id !== quoteId);
    }
  }

  isChecked(quoteId: number, section: string) {
    return section == 'active' ? this.selectedRfq.includes(quoteId) : this.selectedArchivedRfq.includes(quoteId);
  }

  // ── Archive / Unarchive ──

  async rfqOperation(operation: string) {
    if (operation == 'unarchive') {
      if (this.selectedArchivedRfq.length == 0) {
        this.snack.open('Please select at least one', 'OK', { duration: 3000 });
        return;
      }
      this.showLoader = true;
      this.cdr.markForCheck();
      await this.SettingsService.serviceQuoteOperations({
        operation: 'unArchive',
        selectedRfqId: this.selectedArchivedRfq,
      });
      this.selectedArchivedRfq = [];
      await this.fetchAllDocuments();
      if (this.archivedLoaded) await this.fetchArchivedAllDocuments();
      this.snack.open('Items unarchived', 'OK', { duration: 3000 });
    } else if (operation == 'archive') {
      if (this.selectedRfq.length == 0) {
        this.snack.open('Please select at least one.', 'OK', { duration: 3000 });
        return;
      }
      this.showLoader = true;
      this.cdr.markForCheck();
      await this.SettingsService.serviceQuoteOperations({
        operation: 'archive',
        selectedRfqId: this.selectedRfq,
      });
      if (this.expandedQuoteId && this.selectedRfq.includes(this.expandedQuoteId)) {
        this.expandedQuoteId = null;
      }
      this.selectedRfq = [];
      await this.fetchAllDocuments();
      if (this.archivedLoaded) await this.fetchArchivedAllDocuments();
      this.snack.open('Items archived', 'OK', { duration: 3000 });
    }
    this.showLoader = false;
    this.cdr.markForCheck();
  }

  async restore(quoteId: number, operation: string) {
    if (operation == 'unArchive') {
      this.showLoader = true;
      this.cdr.markForCheck();
      await this.SettingsService.serviceQuoteOperations({
        operation: 'unArchive',
        selectedRfqId: [quoteId],
      });
      await this.fetchAllDocuments();
      await this.fetchArchivedAllDocuments();
      this.showLoader = false;
      this.cdr.markForCheck();
      this.snack.open('Item unarchived', 'OK', { duration: 3000 });
    }
  }

  // ── Navigation ──

  openRfqDetails(serviceRfqId: number) {
    this.router.navigate(['/dashboard', 'quote', 'service-rfq-details', serviceRfqId]);
  }

  openQuoteDetails(serviceRfqId: number, quoteId: number) {
    this.router.navigate(['/dashboard', 'quote', 'service-create', 'header'], {
      queryParams: {
        serviceRfqId: serviceRfqId,
        quoteId: quoteId,
      },
    });
  }

  // ── Timeline / Expand ──

  toggleExpandedRow(row: any) {
    this.expandedQuoteId = this.expandedQuoteId === row.quoteId ? null : row.quoteId;
    if (this.expandedQuoteId === row.quoteId && !row.statusesStages) {
      row.statusesStages = this.buildRfqStages(row);
      row.statusesStages = this.buildQuoteStages(row);
      row.statusesStages = this.buildOtherStages(row);
      this.cdr.markForCheck();
    }
  }

  getStageColorClass(label: string, row: any): string {
    if (row.showLiveTrackerRed) return 'stage-declined';
    switch (label) {
      case 'RFQ Declined': return 'stage-declined';
      case 'RFQ Lapsed': return 'stage-lapsed';
      default: return 'stage-completed';
    }
  }

  getCompleteIncompleteClass(stage: any): string {
    return stage.completed ? '' : 'stage-incomplete';
  }

  buildRfqStages(rfq: any) {
    const sortedStages = (rfq.rfqStatusStages || []).sort(
      (a: any, b: any) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
    );
    const stagesArray: any[] = [];
    let hasAcknowledged = false;
    let hasDeclined = false;
    let hasUnactioned = false;

    for (let stage of sortedStages) {
      if (stage.statusName === 'Acknowledged') hasAcknowledged = true;
      else if (stage.statusName === 'Declined') hasDeclined = true;
      else if (stage.statusName === 'Unactioned') hasUnactioned = true;
    }

    if (!hasUnactioned) {
      stagesArray.push({
        heading: this.getHeadingFromLabel('Unactioned', 'RFQ'),
        label: 'RFQ Unactioned', date: this.formatDate(rfq.rfqDate), completed: true,
      });
    }

    sortedStages.forEach((stage: any) => {
      stagesArray.push({
        heading: this.getHeadingFromLabel(stage.statusName, 'RFQ'),
        label: `RFQ ${stage.statusName}`, date: this.formatDate(stage.createdAt), completed: true,
      });
    });

    if (rfq.docStatus === 'Lapsed' && !stagesArray.some(s => s.label === 'Lapsed')) {
      stagesArray.push({
        heading: this.getHeadingFromLabel('Lapsed', 'RFQ'),
        label: 'RFQ Lapsed', date: this.formatDate(rfq.quotedByDate), completed: true,
      });
    }

    if (!hasAcknowledged && !hasDeclined && (rfq.quoteStatusStages || []).length == 0) {
      stagesArray.push({
        heading: this.getHeadingFromLabel('Acknowledged', 'RFQ'),
        label: 'RFQ Acknowledged', date: '', completed: false,
      });
    }
    if (hasDeclined) {
      rfq.quoteStatusStages = [];
      rfq.showLiveTrackerRed = true;
    }

    return stagesArray;
  }

  buildQuoteStages(rfq: any) {
    const sortedStages = (rfq.quoteStatusStages || []).sort(
      (a: any, b: any) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
    );
    const stagesArray: any[] = rfq.statusesStages || [];
    let hasSubmitted = false;
    let hasApproved = false;
    let hasRejected = false;

    for (let stage of sortedStages) {
      if (stage.statusName === 'Submitted') hasSubmitted = true;
      else if (stage.statusName === 'Approved') hasApproved = true;
      else if (stage.statusName === 'Rejected') hasRejected = true;
    }
    if (hasRejected) rfq.showLiveTrackerRed = true;

    sortedStages.forEach((stage: any) => {
      if (stage.statusName == 'Acknowledged') {
        stagesArray.push({
          heading: this.getHeadingFromLabel(stage.statusName, 'Quote'),
          label: 'Quotation Created', date: this.formatDate(stage.createdAt), completed: true,
        });
      } else {
        stagesArray.push({
          heading: this.getHeadingFromLabel(stage.statusName, 'Quote'),
          label: `Quotation ${stage.statusName}`, date: this.formatDate(stage.createdAt), completed: true,
        });
      }
    });

    if (!hasSubmitted && !hasRejected && !hasApproved) {
      stagesArray.push({ heading: this.getHeadingFromLabel('Submitted', 'Quote'), label: 'Quotation Submitted', date: '', completed: false });
    }
    if (!hasApproved && !hasRejected) {
      stagesArray.push({ heading: this.getHeadingFromLabel('Approved', 'Quote'), label: 'Quotation Approval', date: '', completed: false });
    }

    return stagesArray;
  }

  buildOtherStages(rfq: any) {
    let stagesArray = rfq.statusesStages || [];
    stagesArray.push({ heading: 'PO Confirmation', label: 'PO Confirmation', date: '', completed: false });
    stagesArray.push({ heading: 'Delivered Onboard', label: 'Delivered', date: '', completed: false });
    return stagesArray;
  }

  // ── Preview / Contact ──

  togglePreview(value: boolean, row?: any) {
    this.previewSection = value;
    this.previewDocs = [];
    if (row) {
      this.previewDocs = [...(row.quoteHeaderAttachments || []), ...(row.quoteLineItemAttachments || [])];
    }
  }

  toggleContactPopUp(value: boolean, row?: any) {
    this.showContactPopup = value;
    if (value && row) {
      this.selectedBuyer = {
        companyName: row.buyerCompanyName,
        contactPerson: row.buyerContact,
        email: row.companyEmailId,
        phone: row.buyerCompanyPhoneNumber,
        address: row.buyerCompanyAddress,
        fax: row.buyerCompanyFax,
      };
    }
  }

  // ── Print / Download (placeholders) ──

  downloadQuote(refNo: string, row: any) {
    this.snack.open('Print feature not yet implemented for service quotes.', 'OK', { duration: 3000 });
  }

  generateQuoteExcel(quoteId: number, serviceRfqId: number, supplierId: number, ref: string) {
    this.snack.open('Download feature not yet implemented for service quotes.', 'OK', { duration: 3000 });
  }

  // ── Export All ──

  async fetchAllQuotes() {
    try {
      const response = await this.SettingsService.fetchServiceQuoteDetailsBySupplierId(
        this.searchParam,
        Number(this.cookieService.get('userId')),
        this.docStatus,
        null,
        null,
        '',
        '',
        0,
        0,
        1,
        'exportAll'
      );
      if (response && Array.isArray(response.rows)) {
        this.AllQuotes = response.rows;
      }
    } catch (error) {
      console.error('Error fetching all service quotes for export:', error);
      throw error;
    }
  }

  async exportAllQuotes() {
    try {
      this.fullLoaderService.showLoader('Exporting Service Quote Details...');
      const XLSX = await import('xlsx');

      await this.fetchAllQuotes();

      if (!this.AllQuotes || this.AllQuotes.length === 0) {
        this.snack.open('No Quotes available to export.', 'OK', { duration: 5000 });
        return;
      }

      const exportData: any[] = this.AllQuotes.map((q: any, index: number) => ({
        'Sr. No.': index + 1,
        'Quote Reference': q.quoteRefNumber || '',
        'RFQ Reference': q.rfqRefNumber || '',
        'Port Name': q.portName || '',
        'Vessel Name': q.vesselName || '',
        'Buyer': q.companyName || '',
        'Status': this.quoteStatuses[q.quoteStatus - 1] || '',
        'Quote Submission Date': q.quotationDate || '',
        'Request For Delivery Date': q.requestDeliveryDate || '',
        'Quote Before Date': q.quotedByDate || '',
        'Vessel ETA': q.vesselEta || '',
        'Vessel ETD': q.vesselEtd || '',
        'Price Good Until': q.pricesGoodUntil || '',
        'Payment Terms': q.paymentTermsAndConditions || '',
        'Total Price': q.totalPrice || '',
      }));

      const today = new Date();
      const formattedDate = `${String(today.getDate()).padStart(2, '0')}-${String(today.getMonth() + 1).padStart(2, '0')}-${today.getFullYear()}`;
      const fileName = `Service_Supplier_Quotation_List_${formattedDate}.xlsx`;

      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Service Quotes');
      XLSX.writeFile(wb, fileName);

      this.snack.open('Service Quotes data exported successfully!', 'OK', { duration: 5000 });
    } catch (error) {
      console.error('Error while exporting Service Quotes:', error);
      this.snack.open('Failed to export Service Quotes data.', 'OK', { duration: 5000 });
    } finally {
      this.fullLoaderService.hideLoader();
    }
  }

  isColumnVisible(prop: string): boolean {
    const column = this.columns.find(col => col.prop === prop);
    return column ? column.visible : false;
  }
}
